<form [formGroup]="loginForm" (ngSubmit)="onLoginSubmit()">
  <digital-platform-message-bar *ngIf="message$ | async">
    {{ message$ | async }}
  </digital-platform-message-bar>
  <div class="input-container">
    <label>Email</label>
    <mat-form-field appearance="outline">
      <input matInput formControlName="username" />
      <mat-error
        class="error email-required"
        *ngIf="errorHandling('username', 'required')"
      >
        Email is <strong>Required</strong>
      </mat-error>
    </mat-form-field>
  </div>
  <div class="input-container">
    <div class="right label-container">
      <a [routerLink]="['/forgot-password']" tabindex="-1">Forgot Password?</a>
    </div>
    <label>Password</label>
    <mat-form-field appearance="outline">
      <input matInput formControlName="password" type="password" />
      <mat-error
        class="error password-required"
        *ngIf="errorHandling('password', 'required')"
      >
        Password is <strong>Required</strong>
      </mat-error>
    </mat-form-field>
  </div>
  <button mat-flat-button color="accent">Sign in</button>
  <div
    class="register-container"
    *digitalPlatformFeatureFlag="'create-account-enabled'"
  ></div>
</form>
